export const INITIALIZE_ORDER_MUTATION = `
mutation OrderMutation($payload: UpdateUserOrderInfoPayloadDtoInputType!) {
  initialize(payload: $payload) {
    data {
      orderState
      orderId
    }
  }
}
`;
